import React from 'react'

import { useNavigate, useLocation } from 'react-router-dom'

import { Stack, Divider, Typography, IconButton } from '@mui/material'
import { KeyboardArrowLeft } from '@mui/icons-material'

import { useBackButton } from '@/hooks/useBackButton'

import { CardAddForm } from '@/components/CardAddForm'

import { AppRoutes } from '@/routes/types/routes'

const CardAddPage: React.FC = () => {
  useBackButton({ backRoute: AppRoutes.WALLET })

  const navigate = useNavigate()
  const location = useLocation()

  const { from, productId, paymentMethod } = location.state || {}

  const handleOnClickGoBack = () => {
    if (from) {
      navigate(from, { state: { productId, paymentMethod } })
      return
    }

    navigate('/wallet', { state: { tab: 'cards' } })
  }

  const handleSuccess = (cardId?: number) => {
    if (from) {
      navigate(from, { state: { productId, paymentMethod, cardId } })
      return
    }

    navigate('/wallet', { state: { tab: 'cards' } })
  }

  return (
    <Stack paddingTop="24px" paddingX="24px" direction="column">
      <Stack
        direction="column"
        spacing={2}
        sx={{
          paddingTop: 'env(safe-area-inset-top)',
        }}
      >
        <Stack position="relative" direction="row" alignItems="center" justifyContent="center">
          <IconButton onClick={handleOnClickGoBack} sx={{ position: 'absolute', left: 0 }}>
            <KeyboardArrowLeft />
          </IconButton>
          <Typography variant="h6" fontWeight="bold">
            Adicionar cartão
          </Typography>
        </Stack>

        <Divider />

        <CardAddForm onSuccess={handleSuccess} />
      </Stack>
    </Stack>
  )
}

export default CardAddPage
